
import { defineComponent } from "vue";
import SideMenu from "./course/SideMenu.vue";
import { getCourseCatalogue } from "../api/course";
import _ from "lodash";

export default defineComponent({
    name: "Course",
    props: {
        msg: String,
    },
    components: {
        SideMenu,
    },
    data() {
        return {
            catalogue: [] as any,
            menuData: [] as any,
            docSrc: "",
        };
    },
    computed: {
        defaultActiveMenu(): any {
            if (this.menuData.length) {
                const firstDocUuid = this.getFirstDocUuid(this.menuData[0]);
                this.handleSelectMenu(firstDocUuid); // 处理默认选中的菜单
                return firstDocUuid;
            } else {
                return "";
            }
        },
    },
    async mounted() {
        await this.getCatalogue();
    },
    methods: {
        async getCatalogue() {
            const catalogue = await getCourseCatalogue();
            console.log("catalogue", catalogue);
            this.catalogue = catalogue;
            const menuData = this.convert(catalogue);
            console.log("menuData", menuData);
            this.menuData = menuData;
        },
        convert(list: Array<any>) {
            const obj: any = {};
            const res: any = [];
            list.forEach((item) => {
                obj[item.uuid] = item;
            });
            list.forEach((item) => {
                if (item.parent_uuid) {
                    obj[item.parent_uuid]["children"]
                        ? obj[item.parent_uuid]["children"].push(item)
                        : (obj[item.parent_uuid]["children"] = [item]);
                } else {
                    res.push(item);
                }
            });
            return res;
        },
        loadCourseDoc(url: string) {
            console.log("loadCourseDoc", url);
            // const baseUrl = "https://yuque.antfin-inc.com/nor9um/ono5ly"; //内网tide-wanhuatong语雀文档根路径
             const baseUrl = "https://www.yuque.com/kuandong-oy87e/xwos24"; //外网tide-wanhuatong语雀文档根路径
            const options = "view=doc_embed&from=tide&title=1&outline=1";
            this.docSrc = `${baseUrl}/${url}?${options}`;
        },
        getFirstDocUuid(obj: any): any {
            if (obj.children) {
                return this.getFirstDocUuid(obj.children[0]);
            } else {
                return obj.uuid;
            }
        },
        handleSelectMenu(index: any) {
            console.log("index", index);
            const curSelectMenu = this.catalogue.filter((item: any) => {
                return item.uuid === index;
            });
            const menuUrl = _.get(curSelectMenu[0], "url");
            this.loadCourseDoc(menuUrl);
        },
    },
});
